import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { forwardRef } from 'react';
import { isFunction } from 'lodash';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { SearchCommunityFormMainSection } from './SearchCommunityFormMainSection';

export type ISearchCommunityFormBodyValues = {
  search?: string;
  categoryId?: string;
  articleId?: string;
  onlyBadges?: string;
  near?: boolean;
  badgeId?: string;
  type?: string;
};

export type ISearchCommunityFormBodyRenderProps = {
  form: ReturnType<typeof useForm<ISearchCommunityFormBodyValues>>;
};

export type ISearchCommunityFormBodyProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ISearchCommunityFormBodyValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    form?: ReturnType<typeof useForm<ISearchCommunityFormBodyValues>>;
    defaultValues?: DefaultValues<ISearchCommunityFormBodyValues>;
    onSubmit?: SubmitHandler<ISearchCommunityFormBodyValues>;
    appId: string;
    children?:
      | React.ReactNode
      | ((props: ISearchCommunityFormBodyRenderProps) => React.ReactNode);
  };

export const SearchCommunityFormBody = forwardRef<
  HTMLFormElement,
  ISearchCommunityFormBodyProps
>(function SearchCommunityForm(props, ref) {
  const {
    sx,
    form: formProp,
    defaultValues,
    onSubmit,
    appId,
    children,
    ...other
  } = props;
  const ownForm = useForm<ISearchCommunityFormBodyValues>({
    defaultValues,
  });
  const form = formProp ?? ownForm;

  return (
    <ContentBlock.FormBody
      ref={ref}
      sx={sx}
      form={form}
      onSubmit={onSubmit}
      hideActionBar
      {...other}
    >
      <SearchCommunityFormMainSection form={form} appId={appId} />

      {isFunction(children) ? children({ form }) : children}
    </ContentBlock.FormBody>
  );
});
